import React, { Component } from 'react';
import { Navbar, NavbarBrand, NavbarNav, Collapse, NavItem, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faListAlt, faClock, faBuilding, faDatabase, faSignOutAlt, faUpload, faUser, faUsers, faClipboardList, faTabletAlt, faCodeBranch, faHandPointUp, faColumns, faThList, faBox } from '@fortawesome/free-solid-svg-icons';
import { Redirect } from 'react-router-dom';
import RolesType from '../utils/roles';
import axios from 'axios';

class MainLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapse: false,
            isWideEnough: false,
            dropdownOpen: false,
            isAutenticated: false,
            homeActive: true,
            logActive: false,
            userActive: false,
            auditActive: false,
        };
        this.onClick = this.onClick.bind(this);
        this.toggle = this.toggle.bind(this);
        this.logout = this.logout.bind(this);

        if(sessionStorage.getItem("token") !== null && sessionStorage.getItem("token") !== "" && sessionStorage.getItem("token") !== undefined){
            axios.defaults.headers.common['Authorization'] = "Bearer " + sessionStorage.getItem("token");
        }

    }

    onClick() {
        this.setState({
            collapse: !this.state.collapse,
        });
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    logout(e) {
        e.preventDefault();
        this.setState({ isAutenticated: true });
        sessionStorage.setItem("user", '');
        sessionStorage.setItem("token", '');
        sessionStorage.setItem("rol", '');
        sessionStorage.setItem("email", '');
        sessionStorage.clear();

        // var auth2 = window.gapi.auth2.getAuthInstance()
        // if (auth2 != null) {
        //   auth2.signOut().then(this.props.onLogoutSuccess)
        // }
        return (<Redirect to={'/login'} />)
    }

    // hanldeActive(e,name){
    //     e.preventDefault();
    //     if(name === "home"){
    //         this.setState({
    //             homeActive: "nav-item active",
    //             logActive: "nav-item"
    //         },console.log());
    //     }
    //     if(name === "log"){
    //         this.setState({
    //             homeActive: "nav-item",
    //             logActive: "nav-item active"
    //         },console.log());
    //     }
    // }

    renderRoles() {

        let dataResult = RolesType;
        var temp = Object.keys(dataResult);
        //Admin
        if (sessionStorage.getItem("rol") === temp[0]) {
            return <NavbarNav left>
                <NavItem>
                    <NavLink to="/home" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faHome} />&nbsp; Home</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/log" activeStyle={{ backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faListAlt} />&nbsp; Logs</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/device" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faClock} />&nbsp; Device</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/bulk" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faBox} />&nbsp; Bulk</NavLink>
                </NavItem>
                <NavItem >
                    <Dropdown>
                        <DropdownToggle nav caret><span className="text-white" style={{ 'marginRight': '20px' }} ><FontAwesomeIcon icon={faTabletAlt} />&nbsp; Device Updates</span></DropdownToggle>
                        <DropdownMenu >
                            <NavLink to="/Version" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faCodeBranch} />&nbsp; Versions</NavLink>
                            <NavLink to="/CompanyVersion" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faBuilding} />&nbsp; Company Versions</NavLink>
                        </DropdownMenu>
                    </Dropdown>
                </NavItem>
                <NavItem>
                    <NavLink to="/Backup" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faDatabase} />&nbsp; Backup</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/Import" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faUpload} />&nbsp; Migration Tool</NavLink>
                </NavItem>
                <NavItem >
                    <NavLink  to="/user" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faUsers} />&nbsp; Users</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/FingerPrint" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faHandPointUp} />&nbsp; FingerPrint</NavLink>
                </NavItem>
                <NavItem active={this.state.auditActive}>
                    <NavLink                 
                        to="/audit" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faClipboardList} />&nbsp; Audit</NavLink>
                </NavItem>
                <NavItem>
                    <Dropdown>
                        <DropdownToggle nav caret><span className="text-white" style={{ 'marginRight': '20px' }}><FontAwesomeIcon icon={faColumns} />&nbsp; API</span></DropdownToggle>
                        <DropdownMenu>
                            <NavLink to="/construction" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faThList} />&nbsp; Logs</NavLink>
                            <NavLink to="/api" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faBuilding} />&nbsp; Integrations</NavLink>
                        </DropdownMenu>
                    </Dropdown>
                </NavItem>
            </NavbarNav>
        }

           //Dev_Team
           if (sessionStorage.getItem("rol") === temp[1]) {
            return <NavbarNav left>
                <NavItem >
                    <NavLink to="/home" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faHome} />&nbsp; Home</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/log" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faListAlt} />&nbsp; Logs</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/device" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faClock} />&nbsp; Device</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/bulk" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faBox} />&nbsp; Bulk</NavLink>
                </NavItem>
                <Dropdown>
                    <DropdownToggle nav caret><span className="text-white" style={{ 'marginRight': '20px' }}><FontAwesomeIcon icon={faTabletAlt} />&nbsp; Device Updates</span></DropdownToggle>
                    <DropdownMenu>
                         <NavLink to="/Version" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faCodeBranch} />&nbsp; Versions</NavLink>
                         <NavLink to="/CompanyVersion" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faBuilding} />&nbsp; Company Versions</NavLink>
                    </DropdownMenu>
                </Dropdown>
                <NavItem>
                    <NavLink to="/Backup" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faDatabase} />&nbsp; Backup</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/Import" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faUpload} />&nbsp;  Migration Tool</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/FingerPrint" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faHandPointUp} />&nbsp; FingerPrint</NavLink>
                </NavItem>
                <NavItem>
                    <Dropdown>
                        <DropdownToggle nav caret><span className="text-white" style={{ 'marginRight': '20px' }}><FontAwesomeIcon icon={faColumns} />&nbsp; API</span></DropdownToggle>
                        <DropdownMenu>
                            <NavLink to="/construction" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faThList} />&nbsp; Logs</NavLink>
                            <NavLink to="/api" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faBuilding} />&nbsp; Integrations</NavLink>
                        </DropdownMenu>
                    </Dropdown>
                </NavItem>
            </NavbarNav>
        }
         //Support_Team
         if (sessionStorage.getItem("rol") === temp[2]) {
            return <NavbarNav left>
                <NavItem >
                    <NavLink to="/home" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faHome} />&nbsp; Home</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/log" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faListAlt} />&nbsp; Logs</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/device" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faClock} />&nbsp; Device</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/bulk" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faBox} />&nbsp; Bulk</NavLink>
                </NavItem>
                <Dropdown>
                    <DropdownToggle nav caret><span className="text-white" style={{ 'marginRight': '20px' }}><FontAwesomeIcon icon={faTabletAlt} />&nbsp; Device Updates</span></DropdownToggle>
                    <DropdownMenu>
                            <NavLink to="/CompanyVersion" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faBuilding} />&nbsp; Company Versions</NavLink>
                    </DropdownMenu>
                </Dropdown>
                <NavItem>
                    <NavLink to="/Import" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faUpload} />&nbsp;  Migration Tool</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/FingerPrint" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faHandPointUp} />&nbsp; FingerPrint</NavLink>
                </NavItem>
                <NavItem>
                    <Dropdown>
                        <DropdownToggle nav caret><span className="text-white" style={{ 'marginRight': '20px' }}><FontAwesomeIcon icon={faColumns} />&nbsp; API</span></DropdownToggle>
                        <DropdownMenu>
                            <NavLink to="/construction" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faThList} />&nbsp; Logs</NavLink>
                            <NavLink to="/api" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faBuilding} />&nbsp; Integrations</NavLink>
                        </DropdownMenu>
                    </Dropdown>
                </NavItem>
            </NavbarNav>
        }
          //Support_Manager
          if (sessionStorage.getItem("rol") === temp[5]) {
            return <NavbarNav left>
                <NavItem >
                    <NavLink to="/home" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faHome} />&nbsp; Home</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/log" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faListAlt} />&nbsp; Logs</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/device" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faClock} />&nbsp; Device</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/bulk" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faBox} />&nbsp; Bulk</NavLink>
                </NavItem>
                <Dropdown>
                    <DropdownToggle nav caret><span className="text-white" style={{ 'marginRight': '20px' }}><FontAwesomeIcon icon={faTabletAlt} />&nbsp; Device Updates</span></DropdownToggle>
                    <DropdownMenu>
                            <NavLink to="/CompanyVersion" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faBuilding} />&nbsp; Company Versions</NavLink>
                    </DropdownMenu>
                </Dropdown>
                <NavItem>
                    <NavLink to="/Import" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faUpload} />&nbsp;  Migration Tool</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/FingerPrint" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faHandPointUp} />&nbsp; FingerPrint</NavLink>
                </NavItem>
                <NavItem active={this.state.auditActive}>
                    <NavLink                 
                        to="/audit" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faClipboardList} />&nbsp; Audit</NavLink>
                </NavItem>
                <NavItem>
                    <Dropdown>
                        <DropdownToggle nav caret><span className="text-white" style={{ 'marginRight': '20px' }}><FontAwesomeIcon icon={faColumns} />&nbsp; API</span></DropdownToggle>
                        <DropdownMenu>
                            <NavLink to="/construction" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faThList} />&nbsp; Logs</NavLink>
                            <NavLink to="/api" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faBuilding} />&nbsp; Integrations</NavLink>
                        </DropdownMenu>
                    </Dropdown>
                </NavItem>
            </NavbarNav>
        }
        //Reseller_Support
        if (sessionStorage.getItem("rol") === temp[4]) {
            return <NavbarNav left>
                <NavItem>
                    <NavLink to="/device" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faClock} />&nbsp; Device</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/bulk" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}} ><FontAwesomeIcon icon={faBox} />&nbsp; Bulk</NavLink>
                </NavItem>
                <NavItem>
                    <Dropdown>
                        <DropdownToggle nav caret><span className="text-white" style={{ 'marginRight': '20px' }}><FontAwesomeIcon icon={faTabletAlt} />&nbsp; Device Updates</span></DropdownToggle>
                        <DropdownMenu>
                                <NavLink to="/CompanyVersion" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faBuilding} />&nbsp; Company Versions</NavLink>
                        </DropdownMenu>
                    </Dropdown>
                </NavItem>   
                <NavItem>
                    <NavLink to="/Import" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faUpload} />&nbsp;  Migration Tool</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/FingerPrint" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faHandPointUp} />&nbsp; FingerPrint</NavLink>
                </NavItem>
            </NavbarNav>
        }   

        //Upddate Apk   
        if (sessionStorage.getItem("rol") === temp[3]) {
            return <NavbarNav left>
                        <NavItem >
                            <NavLink to="/home" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faHome} />&nbsp; Home</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to="/log" activeStyle={{  backgroundColor: "rgba(255, 255, 255, 0.1)"}}><FontAwesomeIcon icon={faListAlt} />&nbsp; Logs</NavLink>
                        </NavItem>
                        <Dropdown>
                            <DropdownToggle nav caret><span className="text-white" style={{ 'marginRight': '20px' }}><FontAwesomeIcon icon={faTabletAlt} />&nbsp; Device Updates</span></DropdownToggle>
                            <DropdownMenu>
                                <NavLink to="/CompanyVersion" activeStyle={{  backgroundColor: "#DED9D9"}}><FontAwesomeIcon icon={faBuilding} />&nbsp; Company Versions</NavLink> 
                            </DropdownMenu>
                        </Dropdown>
                    </NavbarNav>
        }

    }

    render() {

        if (this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }

        const user = {
            UserName: sessionStorage.getItem("user")
        }
        return (
            <div className="general">
                <Navbar color="indigo" dark expand="md" scrolling>
                    <NavbarBrand href="/home">
                </NavbarBrand>
                    <Collapse isOpen={this.state.collapse} navbar>
                        {
                            this.renderRoles()
                        }
                        <NavbarNav right>
                            <NavItem>
                                <Dropdown>
                                    <DropdownToggle nav caret><span className="text-white" style={{ 'marginRight': '20px' }}><FontAwesomeIcon icon={faUser} />&nbsp; {user.UserName}</span></DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem onClick={(e) => this.logout(e)}> <FontAwesomeIcon icon={faSignOutAlt} />&nbsp; Logout</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </NavItem>
                        </NavbarNav>
                    </Collapse>
                </Navbar><br />
            </div>
        );
    }
    // componentWillUpdate(prevProps, prevState){
    //     console.log("component will update")
    //     console.log(prevState)
    // }
}
export default MainLayout;


// WEBPACK FOOTER //
// ./src/layout/layout.jsx